import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import { BrowseEpisodes } from './pages/BrowseEpisodes.tsx'
import { ManageNotifications } from './pages/ManageNotifications.tsx'
import { StationSlugContext } from './contexts/StationSlugContext.ts'

// Detect station slug from /app/{slug}/ path prefix for per-station PWA scoping
function getAppSlug(): string | null {
  const match = window.location.pathname.match(/^\/app\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

const appSlug = getAppSlug();
const basename = appSlug ? `/app/${appSlug}` : '';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StationSlugContext.Provider value={appSlug}>
      <BrowserRouter basename={basename}>
        <Routes>
          <Route path="/browse" element={<BrowseEpisodes />} />
          <Route path="/shows" element={<App />} />
          <Route path="/schedule" element={<App />} />
          <Route path="/notifications" element={<ManageNotifications />} />
          <Route path="/:episodeId" element={<App />} />
          <Route path="/" element={<App />} />
        </Routes>
      </BrowserRouter>
    </StationSlugContext.Provider>
  </StrictMode>,
)
